import React from 'react'
import { Link, Redirect } from 'react-router-dom';
import Show from 'services/Show';
import { handleErrors, formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';
import AutocompleteAsync from 'components/AutocompleteAsync';


export default class ShowExperts extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      busy: false,
      show: {},
      showId: match.params.id,
      successSave: false,
      changed: false,
    }
    this.mounted = false;
    this.nextStepUrl = '/shows/'+ match.params.id + '/experts/by-breeds';
    this.nextRingsUrl = '/shows/'+ match.params.id + '/experts/rings';
  }

  componentDidMount() {
    this.mounted = true;
    this.loadData();
  }
  
  componentWillUnmount() {
    this.mounted = false;
  }

  loadData = () => {
    this.setState({loading: true});
    Show.get(this.state.showId, {with_experts: true}).then(show => {
      if (this.mounted) {
        this.setState( { show, loading: false } );
      }
    }).catch((request) => {
      this.setState({loading: false});
      handleErrors(request);
    });
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  addExpert = ({target: {value}}) => {
    const show = this.state.show;
    let already_added = show.invited_experts.find(expert => expert.id === value.id)
    if (!already_added) {
      show.invited_experts.push(value);
      this.setState({show, changed: true});
    }
  }

  removeExpert = ({target: {value}}) => {
    const show = this.state.show;
    const idToRemove = value*1;
    show.invited_experts = show.invited_experts.filter(expert => expert.id !== idToRemove)
    this.setState({show, changed: true});
  }

  saveChanges = (e) => {
    e.preventDefault();
    const show = this.state.show;
    show.invited_expert_ids = show.invited_experts.map(expert => expert.id);
    this.setState({ successSave: false, busy:true });
    show.save().then((item) => {
      if (!this.mounted) return; 
      this.setState({ 
        show: item, 
        successSave: true, 
        busy: false,
        changed: false, 
      });
    }).catch((request) => {
      this.setState({busy: false});
      handleErrors(request);
    });
  }

  render() {
    const {show, loading, changed, successSave} = this.state;
    let showInfo = null;
    const canGoNext = !changed && show.invited_experts && show.invited_experts.length;
    if (canGoNext && successSave) {
      return <Redirect to={this.nextStepUrl} />
    }
    
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }

    return (
      <div className="container-fluid">
        <h4>Эксперты выставки - {showInfo}</h4>
        {loading && <Spinner /> }

        { this.state.successSave && 
         <div className="row alert alert-success">
          Список экспертов выставки успешно обновлен.
         </div>}

        <div className="col-md-6 col-sm-12 mb-3">
          <label htmlFor="name">Добавить эксперта</label>
          <AutocompleteAsync 
            modelName="expert" name="name" url="/autocomplete/objects" 
            labelProp="name" 
            onChange={this.addExpert} />
        </div>
        
        <ul className="list-group">
          {(show.invited_experts || []).map(expert => (
            <li key={expert.id} className="list-group-item mb-2">
              <button value={expert.id} disabled={expert.breeds_count} onClick={this.removeExpert} className="btn btn-danger float-end btn-sm me-3">Убрать</button>
              <strong className="col-xl-3 col-lg-6">{expert.name}</strong>
              <div className="col-5">
                судит 
                &nbsp;
                {expert.breeds_count ? <Link to={`/shows/${show.id}/experts/${expert.id}/sort-breeds`} title="упорядочить">{expert.breeds_count || 0} пород</Link> : ' 0 пород '}
                &nbsp;
                на выставке
              </div>
            </li>)
          )}
        </ul>

        <div className="row">
          <div className="col-md-12 mb-3">
            <button type="button" onClick={this.saveChanges} disabled={!changed || this.state.busy} className="btn btn-primary me-2">
              { this.state.busy && <Spinner /> }
              Сохранить и перейти к выбору пород
            </button>
            <button type="button" onClick={this.onCancel} disabled={this.state.busy} className="btn btn-light">
              { this.state.busy && <Spinner /> }
              Назад
            </button>
          </div>
          {canGoNext ? (
            <div className="col-md-12 mb-3">
              <Link to={this.nextStepUrl} className="btn btn-info ms-4">перейти к выбору пород</Link>
              <Link to={this.nextRingsUrl} className="btn btn-success ms-4">проставить ринги</Link>
            </div>) : null }
        </div>

      </div>
    );
  }
}

